/* eslint-disable @typescript-eslint/naming-convention */

import type { FileFormatMap } from '@/utils/file/const/fileFormats'

export const pointAiAttachmentFileFormats = {
  '.pdf': 'application/pdf',
  '.txt': 'text/plain',
  '.docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
} satisfies FileFormatMap
